import { Box, Fade, IconButton, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { ArrowForwardRounded, FileCopy, Link } from "@mui/icons-material";
import { useState } from "react";

interface Props
{
    state: string;
    textClassName?: string;
    iconClassName?: string;
    linkUrl: string;
    gotoAction?: (state: string) => void;
}

const useStyles = makeStyles(theme => ({
    container: {
        zIndex: 1000,
        display: "flex",
        padding: "1px"
    },
    text: {
        cursor: "pointer"
    }
}));

export function StateTools({ state, textClassName, iconClassName, linkUrl, gotoAction }: Props)
{
    const classes = useStyles();
    const [copiedRecently, setCopiedRecently] = useState(false)

    const copyToClipboard = (text: string) =>
    {
        navigator.clipboard.writeText(text);
        setCopiedRecently(true);
        setTimeout(() =>
        {
            setCopiedRecently(false);
        }, 300);
    }

    return (
        <Box className={classes.container}>
            {gotoAction &&
            <IconButton className={iconClassName} size={"small"} onClick={() => { gotoAction(state) }}>
                <ArrowForwardRounded />
            </IconButton>}
            <IconButton className={iconClassName} size={"small"} onClick={() => { copyToClipboard(linkUrl) }}>
                <Link />
            </IconButton>
            <Box sx={{ paddingTop: "2px", paddingLeft: "2px" }}>
                <Typography className={`${textClassName} ${classes.text}`} onClick={() => { copyToClipboard(state) }}>
                    {state}
                </Typography>
            </Box>
            <Fade in={copiedRecently}><FileCopy /></Fade>
        </Box>
    );
}